import { BaseResponse } from "../BaseResponse";

export class CreateOrganizationKeyResponse extends BaseResponse {
    encryptionKey: string;
    dataKey: string;
    serverResponse: CreateOrganizationKeyResponse;
}